<template>
  <div class="gallery-container">
    <div class="gallery-header-wrapper">
      <div class="filter-button-wrapper fly-in-delay-1 fade-in">
        <!-- <div
          v-show="!filterButtonActiveFlag"
          class="ten-mails-button pre" @click="handlePagination('prev')"
        >
          上10封
        </div> -->
        <div
          :class="{
            'filter-button': true,
            'active': !filterButtonActiveFlag,
          }"
          @click="handleShowFullMemory(1)"
        >
          所有信件
        </div>
        <div>|</div>
        <div
          :class="{
            'filter-button': true,
            'active': filterButtonActiveFlag,
          }"
          @click="handleShowFeaturedMemory()"
        >
          精選信件
        </div>
        <!-- <div
          v-show="!filterButtonActiveFlag"
          class="ten-mails-button next" @click="handlePagination('next')"
        >
          下10封
        </div> -->
      </div>
    </div>
    <div v-show="loaderFlag" class="loader-wrapper">
      <img width="132px" height="100px" src="images/loading_small.gif" alt="Loading">
      <div>Loading...</div>
    </div>
    <div
      :class="{
        'gallery-wrapper': true,
        'fly-in-delay-1': true,
        'fade-in': true,
        'gallery-hide': loaderFlag,
      }"
    >
      <Slick
        v-if="memoryListFlag"
        ref="slick"
        :options="{
          dots: false,
          infinite: false,
          speed: 200,
          slidesToShow: computeSlidesToShow,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: computeSlickPadding,
          arrows: false,
          initialSlide: 0,
        }"
        @setPosition="handleSetPosition"
        @swipe="handleSwipe"
        @init="handleInit"
      >
        <MemoryCard
          v-for="(item, index) in memoryList"
          :key="index"
          :memory=item
          :index="index"
        />
      </Slick>
      <div v-show="!loaderFlag" class="direction-button-wrapper pre">
        <div
          v-if="!isMob && currentMailOfPage > computeArrowBounds - 1"
          class="readmore-alt-button"
          :style="{
            width: computeReadmoreWidth,
            left: computeSlickPadding,
          }"
          @click="showFullMemoryCard(memoryList[calcAdjacentIndex(-1)])"
        />
        <div
          v-show="!loaderFlag"
          :class="{
            'direction-button': true,
            'pre-button': true,
            'direction-mail-button' : currentMailOfPage > computeArrowBounds - 1,
            'direction-page-button': currentMailOfPage < computeArrowBounds && currentPage !== 1 && !filterButtonActiveFlag,
          }"
          @click="currentMailOfPage > computeArrowBounds - 1 || filterButtonActiveFlag ? goPreviousMemory() : handlePagination('prev')"
        >
          <img
            v-show="currentMailOfPage > computeArrowBounds - 1"
            src="images/arrows/white_left.svg"
            alt="previous button"
          >
          <img
            v-if="!filterButtonActiveFlag"
            v-show="currentMailOfPage < computeArrowBounds && currentPage !== 1"
            src="images/arrows/gray_left.svg"
            alt="previous button"
          >
          <div
            v-if="!filterButtonActiveFlag"
            v-show="currentMailOfPage < computeArrowBounds && currentPage !== 1"
            class="direction-text"
          >
            上10封
          </div>
        </div>
      </div>
      <div v-show="!loaderFlag" class="direction-button-wrapper next">
        <div
          v-if="!isMob && currentMailOfPage < memoryListLength - computeArrowBounds"
          class="readmore-alt-button"
          :style="{
            width: computeReadmoreWidth,
            right: computeSlickPadding,
          }"
          @click="showFullMemoryCard(memoryList[calcAdjacentIndex(1)])"
        />
        <div
          v-show="!loaderFlag"
          :class="{
            'direction-button': true,
            'next-button': true,
            'direction-mail-button': currentMailOfPage < memoryListLength - computeArrowBounds,
            'direction-page-button': currentMailOfPage >= memoryListLength - computeArrowBounds && currentPage !== totalPage && !filterButtonActiveFlag,
          }"
          @click="currentMailOfPage < memoryListLength - computeArrowBounds || filterButtonActiveFlag ? goNextMemory() : handlePagination('next')"
        >
          <img
            v-show="currentMailOfPage < memoryListLength - computeArrowBounds" 
            src="images/arrows/white_right.svg"
            alt="next button"
          >
          <img
            v-if="!filterButtonActiveFlag"
            v-show="currentMailOfPage >= memoryListLength - computeArrowBounds" 
            src="images/arrows/gray_right.svg"
            alt="next button"
          >
          <div
            v-if="!filterButtonActiveFlag"
            v-show="currentMailOfPage >= memoryListLength - computeArrowBounds"
            class="direction-text"
          >
            下10封
          </div>
        </div>
      </div>
    </div>
    <FullMemoryCard v-if="showFullMemoryCardFlag" :memory="showFullMemory"></FullMemoryCard>
    <div class="write-mail-button-wrapper fly-in-delay-2 fade-in">
      <div class="mail-counter">
        {{computeMailCounter}}
      </div>
      <button
        class="write-mail-button"
        name="write-mail-button"
        @click="goWriteMail"
      >
        我要寫信<br>
        <span class="event-dead">（寫信活動已截止）</span>
      </button>
      
    </div>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils';
import Slick from 'vue-slick';
import '../../node_modules/slick-carousel/slick/slick.css';
import '../../node_modules/slick-carousel/slick/slick-theme.css';
import FullMemoryCard from './FullMemoryCard.vue';
import MemoryCard from './MemoryCard.vue';

export default {
  name: 'MemoryGallery',
  components: {
    Slick,
    FullMemoryCard,
    MemoryCard,
  },
  props: {
    completedFlag: {
      type: Boolean,
    },
  },
  data() {
    return {
      apiUrl: '//newmedia.udn.com.tw/active_laravel/api/memories',
      // apiUrl: '//localhost/memory_collector/public/api/memories',
      // apiUrl: '//nmdap.udn.com.tw/newmedia/memory/api/memories',
      memoryListFlag: false,
      memoryList: {},
      memoryListLength: 0,
      loaderFlag: true,
      featuredMemoryList: [
        {
          name: '沈春華',
          id: -22,
          job: '',
          body: '921的震撼和痛，我閉起雙眼就能清晰浮現 ，媒體紀錄了一道道傷痕，但也帶來黑暗過後的曙光。\n\n當時我們新聞團隊進駐埔里災區，每個分秒的守候，都是一場生死拔河，受困瓦礫堆中86小時生還的張景閎小弟弟，被韓國救難隊員抱出來的時候，我們現場的媒體記者都激動的紅了眼眶。\n\n一場傷亡最慘重的震災，卻也凝聚了國人最強大的愛，媒體的角色幫助了家園重建和傷口撫平。\n\n20年過去了，當年的孩子們都好嗎？但願愛還在、希望還在、媒體還在...',
          color: '3',
          speach: 'https://udn.com/newmedia/921/memory/speaches/memory_212.mp3'
        },
        {
          name: '許效舜',
          id: -21,
          job: '',
          body: '921大地震當天，我正好在南投埔里錄「在台灣的故事」，我們預計要採訪的地方全部都坍塌，整晚都是地鳴聲。\n\n當時的恐懼我至今難忘，大家都互相勉勵要活著回家，很遺憾，最後還是有一個人沒活著回來，我們的編導在回程路上遇到餘震，被落石砸傷，傷重不治。\n\n一轉眼已經20年，編導的孩子也已經20歲。因為經歷了921，我的人生彷彿到了另一個位置。',
          color: '3',
          speach: 'https://udn.com/newmedia/921/memory/speaches/memory_216.mp3'
        },
        {
          name: '導演 魏德聖',
          id: -20,
          job: '',
          body: '921那一天就像一般人一樣，在睡夢中驚醒，由於住台北所以沒有受災，當下有種要逃也來不及的感覺，所以當下就是躺在床上等。\n\n1999年對我是重要的一年，當時還是小助理，有空的時候寫寫劇本，不過那年推出首部短片「七月天」，也寫完「賽德克巴萊」的劇本。',
          color: '3',
          speach: 'https://udn.com/newmedia/921/memory/speaches/memory_214.mp3'
        },
        {
          name: '范范 范瑋琪',
          id: -19,
          job: '',
          body: '范范有首歌叫「每天」，是寫給因921離開的大舅媽。\n那晚，大舅媽突然間說要和舅舅換位子睡，那年是他們結婚40周年，沒想到舅媽一換床位就被壓死，如果沒換，死的就是舅舅。\n范范因為想念她，寫了這首歌紀念。',
          color: '2',
          speach: 'https://udn.com/newmedia/921/memory/speaches/memory_229.mp3'
        },
        {
          name: '黑人 陳建州',
          id: -18,
          job: '',
          body: '黑人范范當年還沒相遇。\n\n黑人那天在中華隊，正赴美宣慰僑胞，其中幾個隊友和教練來自南投，那晚，整個團隊都瀰漫著不安氣氛，擔心台灣家人安危，電話卻永遠不通，想報平安都沒辦法。',
          color: '2',
          speach: 'https://udn.com/newmedia/921/memory/speaches/memory_213.mp3'
        },
        {
          name: '余哲榮',
          id: -17,
          job: '教師/人父',
          body: '當年，老婆大人正懷著第二個寶寶，那一天晚上，很天真也很幸運的以為，只是地震，所以，儘管搖晃厲害，我們一家子還是待在公寓四樓的小主臥裡，沒有出去，也在還算平靜的心情下，睡到天亮。當下，唯一覺得奇怪的是：為什麼其他住家都沒有準備手電筒，每一家都暗暗的？事後才了解，原來大家都跑出去避難了！\n對921真正起了害怕是隔天。\n一早起來，想要燒個熱水幫大兒子沖奶粉，發現沒電也沒瓦斯，於是我騎著摩托車出門打算買早餐，街上的景色，開始衝擊我的情緒：一棟大樓歪斜靠在另一棟大樓身上、一排房子的騎樓不見了，車子只剩下尾部露出來、7-11擠滿了人，架上卻是空的、沒有人賣早餐!!!，這時我才驚覺，原來凌晨的地震是如此的劇烈！\n帶著驚懼的心情，我慌張地尋覓有可能販賣早餐的店家，繞遍大里市區，好不容易，發現一家！這店家也沒電，還好他們使用桶裝瓦斯，地震後，他們佛心的煮出了一鍋鍋菜粥平價販售著，我欣喜的帶著得來不易的早餐回家，餵飽了一家子，但心裡卻開始擔心下一餐…\n餐後，我再度騎車出門，這次的目標是希望購買攜帶式的瓦斯爐與瓦斯罐，但是我逛遍周邊商場，這類型的產品竟然銷售一空，不安的心再度升高，瘋狂地騎著車一直繞一直繞，最終離家不知道多遠，一間瓦斯行出現在幾乎感到絕望的視野裡，興奮的買了一桶小桶瓦斯，雖然這一桶瓦斯當時的價錢是1350元，遠比平時的450元高出許多，但當我帶著它回家，將原本使用天然瓦斯管線的爐子接上它，煮了熱騰騰的一餐、泡了溫暖的牛奶餵飽大兒子後，我的眼淚就因為放鬆不自禁的流了下來…!\n921地震對我們的影響有多深，其實我不是很確定，只知道現在的我，只要想起當時有錢買不到食物的景象，心緒就會控制不住的激動，地面只要有一點晃動，心臟就會劇烈跳動，唯一慶幸的是，還好家人都能平安度過這一切，二兒子也平安到來，想想經歷這一切的大眾，我們是相當感恩的了。',
          color: '1',
          speach: 'https://udn.com/newmedia/921/memory/speaches/memory_209.mp3'
        },
        {
          name: '小陳',
          id: -16,
          job: '攝影記者',
          body: '我那時還是一個懵懂的實習記者，在地震發生後兩天，看到災情嚴重，自己搭著統聯客運，到台中朝馬站租了越野摩托車就往中投公路騎。\n\n下災區的第一餐找不到東西吃，根本沒有商家營業，本想著不要跟災民搶物資，但實在餓得受不了，只好跑到慈濟進駐的小學跟災民一起排隊拿素食炒米粉吃。在那裡看到一輩子難以忘懷的畫面，一個全身灰樸樸的小孩，約莫國小五六年級，拿著一個鋼杯，穿著一雙明顯比他腳大很多的運動鞋，身旁沒有任何一個大人陪伴，排在隊伍裡等著拿食物。\n\n本來慈濟志工看到揹著相機的我，友善說：先給辛苦的記者朋友，但我看到那個孩子，我真的沒有辦法先拿。\n\n那時剛到災區找不到地方住，住在南投市同學家，一棟三層樓的透天厝，同學和家人都沒人敢睡二三樓，都睡在一樓客廳，只有我和另一個也是從台北來的同學傻傻不懂，敢睡二樓，一有餘震，是那種上下跳動的餘震，發現同學和家人一搖就衝出去了，只有我們還呆坐在二樓床上，強震帶給他們深刻的恐懼。\n\n還記得在草屯走過一條馬路，馬路左邊的房子整排倒塌、處處是辦喪事的喪家，右邊看似幸運安好，馬路的中央隆起，一條馬路兩樣情。\n\n在埔里時碰到一位7、80歲的老伯伯，一腳打著石膏坐在家門外，身後是倒塌的房子，那時九二一房子倒塌，才發現很多房子的夾層裡面都是沙拉油桶，根本不牢靠。\n\n我去問了那位老伯，他跟我說：年輕人，這些房子都是我自己蓋的，用沙拉油桶作夾層是為了減輕樓地板重量，以前沒碰過這麼大的地震，都沒問題，這次房子倒成一片才知道嚴重，不是房子不好，是地震真的太大了，「我的兒子、孫子，全都走了」。\n\n我當下愣住了，無法想像那是什麼樣的心情。\n\n屍臭的味道，我一輩子難以忘記，很難形容，沒有什麼味道是跟它一樣的。我剛開始到時只覺得怎麼有股奇怪的味道，聞了很不舒服，想說是消毒水嗎？後來才發現，啊，原來這就是所謂的屍臭。\n\n時光飛逝，居然已經20年了，希望當年的災民們都好，不要再有天災，一切平安。',
          color: '1',
          speach: 'https://udn.com/newmedia/921/memory/speaches/memory_159.mp3'
        },
        {
          name: '阿盛',
          id: -15,
          job: '',
          body: '921我們那邊好像死了300多人，一整排白布，都蓋著，有兩包、有一包，有的一個大一個小，看了你就覺得，怎麼會這樣，怎麼死了這麼多人。\n地震發生時，只知道要把頭抱著，因為東西一直掉下來，我們兩兄弟比較好，沒有被壓到，但爸爸媽媽都走了，碰一聲，什麼都不見了。\n那一村只有我們家裡死兩個，我們的已經蓋著了，離我們200多公尺，有一個人還埋在裡面，我就跟救難隊說，先去救他們吧，我們的已經沒有救了，都壓著怎麼救？他們的喊了還有聲音，我們的都沒有聲了。\n剛開始那一、兩個月，都會聞到味道，屍體臭掉的味道。但我看不到，想說：啊，他有來。我也曾夢過他們，但他們不會跟我講話，他們出現就代表他們在鼓勵你，不是要讓你難過。\n921後，就覺得，你能活多久不知道，昨天還在講話、還在吃飯，碰，隔天就不見了，活在當下快樂就好，不要斤斤計較了。',
          color: 1,
          speach: 'speaches/demo-01-B.mp3'
        },
        {
          name: '周志中',
          id: -14,
          job: '彰基醫院副院長',
          body: '921那一晚，忽然間天搖地動，急診室一些朋友說很嚴重，叫我趕快回去，我二話不說，招了一台計程車趕回彰化。\n回到彰基醫院後，還是搖得很厲害，人一直被送進來，走道大廳全都開放，能夠送開刀房的就趕快緊急開刀，加護病房全部收滿。當時的心情真的是一種莫名的壓力，但覺得要做點事。國軍那時也動員了50幾萬人次，有的國軍弟兄才19歲、20歲，躲在窗角哭，創傷症候群，沒看過這麼多死人。\n隔天我們趕到南投現場，救護車、私人車、卡車，載了20、30個到院前死亡的，都是挖出來的，整個晚上一直載，但沒藥了，只能一直電擊、心肺復甦，醫生說他累到躺在地上，躺在病人的大體旁邊，太累了。\n921那時候，南投忙完回來大概是晚上8點、9點，我還記得那時月亮很圓、高掛在空中，明月在上，才想到，啊應該是中秋，但大家都沒有心情過節，因為很多人的「親」已經不在，完全沒有過節的味道，月黑風高。',
          color: 1,
          speach: 'speaches/demo-02-B.mp3'
        },
        {
          name: '柯文進',
          id: -13,
          job: '消防局小隊長',
          body: '921那天剛洗完澡躺下來，沒多久就發生地震，當下背包都還沒整理，包包背著就跟老婆小孩說，爸爸要去上班了，就回到二里消防消防分隊去待命。\n趕到現場，真的是煉獄，四、五棟大樓全倒、往下塌陷，還有人受傷在哀嚎，地下室在冒煙，一片斷壁殘垣，現場民眾都跑出來，都是很慌亂的表情。\n救援過程中，發現有棟樓底下有車子被壓住，正冒著煙，我和另外兩人怕車子會起火，就拉著水帶鑽到地下去找那幾部車。第一次餘震的時候，因為我在前面，後面的人就抓著我的腳，第三個抓著第。\n搖晃完之後再繼續爬，再往前鑽又發生餘震，我想說奇怪，為什麼這次餘震，我後面的腳沒有人抓了，側身去看，才發現我後面的人已經不見了，找到冒煙車輛時只剩我一個，慢慢的，車開始起火，我就滅火，可是餘震還是一直發生，那空間只剩下你一個，又很黑暗，就很像這個世界只剩下你一個人在這邊。\n那時救災完之後，有一段時間，心裡真的有一段陰影，當時有一段時間真的靠酒精的麻痺，不然我沒辦法睡覺。',
          color: 2,
          speach: 'speaches/demo-03-B.mp3'
        },
        {
          name: '秀秀',
          id: -12,
          job: '',
          body: '剛開始搖時，我們睡上下舖，我還以為是弟弟在搖，後來發現地震，我就先衝去房間找我爸爸媽媽，只是走去房間時，已經整個倒下來了，我哥先衝出去，我也趕緊拉著我弟弟衝出去。\n我那時想說完了，爸爸媽媽會不會是在瓦礫堆裡面。後來親戚幫忙一起挖，爸爸媽媽被抬出來時，兩個人是手牽手的，看到他們牽在一起時真的很感動，人走了手是牽得很緊的，抬出來時是兩個人一起抬出來，讓我知道這真的是幸福。\n921那年我大概11歲，一夕之間房子沒了，爸爸媽媽也走了。小時候住在別人家，有時候會被堂哥取笑我是沒人要的小孩，我覺得很難過，就跟自己說，我一定要找到一個很疼我的老公、很愛我的家人。後來很幸運遇到我老公，我就不像他們講的是沒人要的小孩。\n921過了10年的時候，想到還是會很難過、很害怕，但現在20年，時間久了，心情會慢慢平復，可能因為生了小孩，慢慢更有勇氣、變得更堅強，不會那麼容易哭了。',
          color: 1,
          speach: 'speaches/demo-04-B.mp3'
        },
        {
          name: '廖振益',
          id: -11,
          job: '村長',
          body: '那一晚真的很可怕，以前地震時大家都是讓它搖、繼續睡，那次不一樣，我當時只穿著內褲，把我太太和孫子叫起床，就帶著他們衝出來。\n衝出來後就聽到大家都在叫救命，我先把我太太和孫子放在大路邊，就開始挖了，時間很短，根本沒辦法想太多。救人、挖人的時候，多是在床旁邊或床鋪上挖到的，要逃的時間太短了，那一晚我挖出27個人。\n那一晚大家形容是鬼哭神號，我沒有太大感覺，但那一晚，大家都在哀求地震不要再來了、祈求安全，對我來說，那是我這輩子遇過最嚴重的事。',
          color: 3,
          speach: 'speaches/demo-05-B.mp3'
        },
        {
          name: '陳靜怡',
          id: -10,
          job: '',
          body: '我那時是在睡夢中，凌晨一點多突然一陣搖晃，眼睛睜開時還是亮亮的有燈，突然之間整個就沒電了，天昏地暗，然後一陣很劇烈的搖晃。\n那個時候我在台中，凌晨四五點時聽到廣播，說震央在埔里這邊，而且災情蠻嚴重，橋都斷了，我一直打電話給爸爸媽媽，完全都打不通，我一顆心真的放不下，天一亮就回來埔里了。\n在回來那段路，心情真的很難熬，平常一個小時的車程我開了五、六個小時，這期間完全聯絡不到爸爸媽媽，後來一看到我家還完整健在的時候，我就相信家人一定都在，見到他們的那一刻，我好像從懸崖下面爬上來一樣，覺得自己很幸運，也很感謝老天爺讓他們都還在。\n921讓我懂得怎麼珍惜家人、怎麼和家人相處，而且讓我說出以前不敢說的話。以前或許我們敬愛父母，但我們不會說，當我回來看到爸爸媽媽的那一刻，我覺得擁抱也是921給我的勇氣和表現，沒有什麼是不能說、不能做的。',
          color: 2,
          speach: 'speaches/demo-06-B.mp3'
        },
        {
          name: '林建治',
          id: -9,
          job: '原住民深耕德瑪汶協會執行秘書',
          body: '睡到凌晨，先聽到一些怪聲，風的聲音，然後開始左右搖晃，那時還沒有倒，後來上下搖動，整個部落就平了，沒有心理準備，整個都平了。\n921過程最珍貴的是，剛開始的那兩三天，部落都很自發性的互相幫忙，男生去砍竹子、搭簡易的帳篷，女生也會用自己的方式互相支持，那是最自然的，一定要記住那個過程，記住部落是怎麼站起來的？我們是怎麼互相支持的？\n這一直都在提醒我之後要怎麼發展部落，所以我們會在這裡發展將近二十年，都是靠自己的方式，如果我們沒辦法發展自我支持的模式，那過去的災難都白經歷了，這是最珍貴的。\n我之前是在台北工作，還沒有回到部落以前，在都市找不到重心，很失落很迷惘，但又不知道怎麼回部落。後來因為地震，看到自己的部落變這樣，我還有什麼地方可以去？很自然就這樣留下來。任何人面對這樣的災難，很自然就會留下來，留在自己的家鄉，而且在家鄉裡面，因為養分都是在自己的部落，我也發現這才是可以真正讓我成長、找到生命重心的地方。',
          color: 1,
          speach: 'speaches/demo-07-B.mp3'
        },
        {
          name: '邱慶禧',
          id: -8,
          job: '南投縣生活重建協會理事長',
          body: '921那晚我是被搖醒的，然後電視機砸下來，嚇醒第一時間就趕快抱小孩，正打算從屋裡逃出來，結果樓梯瞬間不見了，只能從二樓爬下來。\n那一天我們搶救了一、二十個，包含受傷、往生的，第二天剛好有一個餘震蠻大的，我生平不曾看過九九峰會跳舞，整個山頭都是霧茫茫的、都是白煙，山頭上完全沒有樹了，都被搖下來，光禿禿的一片。\n我們這邊那天大概往生15個左右，福龜全倒的大概319間，半倒的318間，我們住家也是全倒，我就把土地捐給協會，建構一個社工的辦公室、日照中心，大概建地5、600坪，全數捐給協會來做使用。\n你說921讓我看到什麼? 讓我體會到什麼? 我坦白講，從人最貧困的時候，你伸出援手幫忙他，讓他有一頓溫飽，讓他走出悲情、重生，讓他恢復到日常生活，那是我們內心最大的欣慰。',
          color: 1,
          speach: 'speaches/demo-08-B.mp3'
        },
        {
          name: '阿健',
          id: -7,
          job: '',
          body: '我們家是四層樓的建築，我和弟弟妹妹睡在三樓。發生地震時，我起來去叫爸爸媽媽起床，我媽媽有回應我，後來又連續強震，到樓梯口時，樓梯已經變形了，沒辦法往下走，我就帶我弟我妹靠著門框，至少穩固一點，後來最強震出現，看到沙發在空中翻滾，整個玻璃外牆都往路面倒，等到再過20、30分鐘，呼叫都沒有聲音了，聽到腳步聲往外看，才發現三樓已經變成一樓的高度，一、二樓都坍塌了。\n爸爸媽媽應該是在最強震那時候就離開了。剛把他們找出來時真的是崩潰大哭，一半也是嚇到，覺得不是這樣吧，假的吧，不太能夠接受事情真的發生。\n發生後的一兩個禮拜內，我就必須接受這個事情是真的，在這過程中，我給自己的調適是，父母親早晚會離開，只是他們來得很突然，讓我們必須提早面對這件事。\n我把父母離開這件事看得比較理性，生活中其實不太會特別想到他們不在這件事，有人問我，你爸媽呢？我都會說他們出國了，去天國。\n對我來講，我會覺得他們好像是搬到其他地方生活了，不太方便連絡，這樣子想會覺得比較舒服簡單一點，也不會覺得他們是不見了，或是不在了這樣。',
          color: 1,
          speach: 'speaches/demo-09-B.mp3'
        },
        {
          name: '張家樂',
          id: -6,
          job: '記者',
          body: '921地震後，那個禮拜餘震不斷，幾乎每天都搖啊搖的，當時辦公室半倒，我們就帶著筆電移到汽車旅館，汽車旅館有水有電，可是沒有電腦桌，我們每個人都趴在彈簧床上打稿。\n打完一則稿子腰酸背痛，開車出來南投街上繞一繞，那時半夜12點，我看到里長帶著20、30個里民，20、30人半夜跪在路口，雙手合十，在拜拜、在求天，拜託天饒了我們，不要再一直餘震不斷，我當時真的很shock，因為人類文明、科技到這個程度，面對自然的反撲，一點辦法都沒有，到後來只能跪下來求天，放了我們吧，那個畫面我到現在記憶猶新。\n這場災變最大的啟示是，人生不可預測的未來太多了，我們的計畫、打算，跟朋友、家人的約定，都可能瞬間改變，生離死別的改變，這種不可測的太多了',
          color: 3,
          speach: 'speaches/demo-10-B.mp3'
        },
        {
          name: '謝雙雙',
          id: -5,
          job: '音樂老師',
          body: '921時餐廳剛開1年半，正要開始回本，一夕之間變負的，大概花了整整10年才把負債打平。\n我們那時逃出來是逃到體育場，那時看到天是紅的，感覺好像世界末日，在那麼深的夜裡天竟然是紅的。\n那時會覺得，世界是停下來的，就只是日升日落而已，對我來說沒有任何意義，只知道天亮了、天黑了，這樣的感覺持續了好多年，不是所謂地不搖了，就沒事了。我講真的，心是亂的，要面對好多事情，包括債主。非常多年以後才能安靜的看那一段。\n回頭看才發現，我現在所有的收穫都從921來的。因為在逆境當中，我就必須想辦法去提升自己、讓自己活下去，那時候很艱困，要先把負債歸零，只要跟音樂有關，可以賺錢的，我都會去做。\n我想說，謝謝921，讓我從一個軟弱的小女子長成一個勇敢的人，感謝921，讓我可以在幽暗當中有很多的盼望，因為921，讓我變成一個超乎我所求所想的人。',
          color: 1,
          speach: 'speaches/demo-11-B.mp3'
        },
        {
          name: '劉貴圓',
          id: -4,
          job: '',
          body: '921那時我們在睡覺，忽然間聽到爆發三聲，這三聲爆完，大家爬到床鋪上，看了凌晨1點47分，就說為甚麼大陸會打空包彈過來，三聲還沒完就開始在搖了，搖兩下，電力消失，第三、第四下，旁邊這棟房子倒下來。\n搖的時候把我們房子整個拱起來了，大家爬起來要溜到床鋪下時已經太慢了，房間門已經頂住了，後來只好趴在地上隨他搖，這三聲爆完，把地層整個掏空，剩下地層石壁，從上方的土地移下來，到我們家後面。\n921發生時，我們這棟房子剛蓋好沒多久，結果一下子土地、房子都沒了，有一陣子我活著比死了還痛苦。現在我們也看很開了，沒有甚麼可以斤斤計較，真的，因為人生就是這樣，短短幾十年而已。',
          color: '1',
          speach: 'speaches/demo-12-B.mp3'
        },
        {
          name: '是元介',
          id: -3,
          job: '15歲青少年',
          body: '921大地震發生那年我15歲，一旦進入睡眠就熟睡的我其實當晚感覺到搖晃時地震已經要結束了，等到隔天起來看新聞聽大家聊著才知道強震帶來的災害有多巨大多可怕。\n\n但真正讓我進入地震災後的害怕及恐懼是在2016年拍攝電影「老師你會不會回來」時體會到，電影中還原當年災後的街道景象，因為太真實，走在那場景裡感受到了無助跟絕望的心情，然而卻又有一股力量期盼找到存活著的人，我想經歷過那一晚的人們應該都有過這樣的難受心情。面對大自然強大的力量讓人類顯得脆弱渺小，但是我們不能放棄站起來的希望，人跟人之間的感情也不會因災難而崩塌，重建生活無論需要多久，但生命的重量與能量也是強大的，我們都要擁有不放棄希望的正能量好讓自己更加強大保護自己所愛的人。',
          color: '2',
          speach: 'https://udn.com/newmedia/921/memory/speaches/memory_215.mp3'
        },
        {
          name: '作家劉克襄',
          id: -2,
          job: '',
          body: '每次經過草屯，都會遠眺99峰。\n\n二十年前的天崩地裂，一夕禿裸，雖然慢慢青翠回來，但曾經白山皓皓的龐大與連綿，彷彿繼續在裡面，隱隱的，高聳的提醒著。',
          color: '2',
          speach: 'https://udn.com/newmedia/921/memory/speaches/memory_210.mp3'
        },
        {
          name: '懷舊達人 張哲生',
          id: -1,
          job: '',
          body: '1999年9月21日，凌晨一點多，我們全家人還沒睡，正一起坐在客廳聊天時，突然間一陣天搖地動！\n\n這是父親生前和我們一起經歷的最後一件令人記憶深刻的事，也是我這輩子至今經歷過最可怕的地震。\n\n接下來電力中斷，餘震不斷，我趕緊找出手電筒和收音機，從廣播中，赫然發現事態之嚴重已超出想像。\n\n到了白天，我們一家人開車出去在市區裡繞來繞去，竟找不到有營業的餐廳，而怵目驚心的損壞景象猶歷歷在目。',
          color: '1',
          speach: 'https://udn.com/newmedia/921/memory/speaches/memory_211.mp3'
        },
      ],
      featuredMemoryListLength: 22,
      featuredMemoryIndexList: [],
      cardTranslation: 0,
      cartTransitionStep: 300,
      filterButtonActiveFlag: false,
      showFullMemoryCardFlag: false,
      showFullMemory: {},
      currentMailOfPage: 0,
      parPageMail: 0,
      currentPage: 1,
      lastPage: 1,
      totalPage: 1,
      totalMail: 0,
      totalMailWithFeatured: 0,
    };
  },
  computed: {
    isMob() {
      return window.innerWidth < 1024 ? true : false;
    },
    computeSlickPadding() {
      if (window.innerWidth > 1280) {
        return '15vw';
      } else if (window.innerWidth > 1024 && window.innerWidth <= 1280){
        return '5vw';
      } else {
        return '8vw'
      }
    },
    computeSlidesToShow() {
      if (window.innerWidth < 1024) {
        return 1;
      } else {
        return 3;
      }
    },
    computeArrowBounds() {
      if (window.innerWidth < 1024) {
        return 1;
      } else {
        return 2;
      }
    },
    computeReadmoreWidth() {
      if (window.innerWidth > 1280) {
        return 'calc((100vw - 30vw) / 3 + 4%)';
      } else if (window.innerWidth > 1024 && window.innerWidth <= 1280){
        return 'calc((100vw - 10vw) / 3 + 4%)';
      } else {
        return 'calc((100vw - 16vw) / 3 + 4%)';
      }
    },
    computeMailCounter() {
      if (this.filterButtonActiveFlag)
        return this.currentMailOfPage + 1 + '/' + this.featuredMemoryListLength;
      else
        return (this.currentPage - 1) * 10 + this.currentMailOfPage + 1 + '/' + this.totalMailWithFeatured;
    },
  },
  methods: {
    fetchMemoryList(page_url) {
      // page_url = page_url || window.location.protocol + '//newmedia.udn.com.tw/memory/api/memories';
      // page_url = page_url || 'http://nmdap.udn.com.tw/newmedia/memory/api/memories';
      page_url = page_url ? window.location.protocol + this.apiUrl + '?page=' + page_url : window.location.protocol + this.apiUrl;

      // Not at last page.
      function handleFetchNotLastPage(res, vm) {
        let listArray = [];
        // Insert memory of current page.
        res.data.map((e)=> {
          if (e.speach) {
            e.speach = 'https://udn.com/newmedia/921/memory/speaches/' + e.speach;
          }
          listArray.push(e);
        });
        // listArray.reverse();
        vm.memoryList = {...listArray};
      }
      // At last page, adds featured memory.
      function handleFetchLastPage(res, vm) {        
        let needFeaturedMemoryAmount = (vm.perPageMail - vm.totalMail % 10) % 10;
        
        // Insert featured memory.
        let listArray = [];
        for (let i = 0; i < needFeaturedMemoryAmount; i++) {
          listArray.push(vm.featuredMemoryList[i])
        }
        // Insert memory of current page.
        res.data.map((e)=> {
          if (e.speach) {
            e.speach = 'https://udn.com/newmedia/921/memory/speaches/' + e.speach;
          }
          listArray.push(e);
        });
        listArray.reverse();
        vm.memoryList = {...listArray};        
      }

      fetch(page_url)
        .then(res => res.json())
        .then(res => {
          this.perPageMail = res.meta.per_page;
          this.lastPage = res.meta.last_page;
          this.totalMail = res.meta.total;
          this.totalMailWithFeatured = this.totalMail + this.featuredMemoryListLength;
          this.totalPage = Math.ceil(this.totalMailWithFeatured / this.perPageMail);
          
          if (this.currentPage === this.lastPage) handleFetchLastPage(res, this);
          else handleFetchNotLastPage(res, this);
        })
        .then(() => {
          this.loaderFlag = false;
          this.memoryListFlag = true;
          this.memoryListLength = Object.keys(this.memoryList).length;
        })
        .catch(err => console.log(err));
    },
    goWriteMail() {
      // call root function
      this.$root.$children[0].changeWriteMailFlag();

      window.ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'Button',
        eventAction: 'click',
        eventLabel: `[${Utils.detectPlatform()}] [Write]`,
      });
    },
    handleSetPosition(event, slick) {
      this.currentMailOfPage = slick.currentSlide;
    },
    handleSwipe(event, slick, direction) {
      this.currentMailOfPage = slick.currentSlide;
    },
    handleInit(event, slick) {
      this.currentMailOfPage = slick.currentSlide;
    },
    handlePagination(dir) {
      this.currentPage = (dir === 'next' ? Math.min(this.currentPage + 1, this.totalPage) : Math.max(this.currentPage - 1, 1));
      if (this.currentPage <= this.lastPage) {
        // In page list
        this.handleShowFullMemory();
      } else {
        // Out of page list, remaining featured memory.
        let needFeaturedMemoryAmount = (this.perPageMail - this.totalMail % 10) % 10;
        let startFeaturedMemory = needFeaturedMemoryAmount + this.perPageMail * (this.currentPage - this.lastPage - 1);
        
        let endFeaturedMemory = startFeaturedMemory +
          (this.currentPage < this.totalPage ?
          this.perPageMail :
          (this.featuredMemoryListLength - needFeaturedMemoryAmount) % this.perPageMail)

        this.tempMemoryList = [];
        for (let i = startFeaturedMemory; i < endFeaturedMemory; i++) {
          this.tempMemoryList.push(this.featuredMemoryList[i])
        }

        this.loaderFlag = true;        
        this.memoryList = {...this.tempMemoryList};
        this.memoryListLength = Object.keys(this.memoryList).length;
        this.$refs.slick.destroy();

        this.$nextTick(() => {
          this.$refs.slick.create();
          setTimeout(() => {
            this.loaderFlag = false;
          }, 300);
        });
      }
      window.ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'Button',
        eventAction: 'click',
        eventLabel: `[${Utils.detectPlatform()}] [${dir} 10]`,
      });
    },
    handleShowFullMemory(page) {
      // 如果從「所有信件button導入」
      if (page) this.currentPage = page;
      this.filterButtonActiveFlag = false;
      this.loaderFlag = true;
      
      // render memoryList
      this.fetchMemoryList(this.currentPage);
      this.$refs.slick.destroy();

      this.$nextTick(() => {
        this.$refs.slick.create();
        setTimeout(() => {
          this.loaderFlag = false;
        }, 300);
      });

      window.ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'Button',
        eventAction: 'click',
        eventLabel: `[${Utils.detectPlatform()}] [All]`,
      });
    },
    handleShowFeaturedMemory() {
      this.filterButtonActiveFlag = true;
      this.loaderFlag = true;

      // render featuredMemoryList
      this.memoryList = {...this.featuredMemoryList};
      this.memoryListLength = Object.keys(this.memoryList).length;
      this.$refs.slick.destroy();
      this.$nextTick(() => {
        this.$refs.slick.create();
        setTimeout(() => {
          this.loaderFlag = false;
        }, 300);
      });

      window.ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'Button',
        eventAction: 'click',
        eventLabel: `[${Utils.detectPlatform()}] [Selected]`,
      });
    },
    showFullMemoryCard(memory) {
      if (!this.showFullMemoryCardFlag) {
        this.showFullMemory = {...memory};
        this.showFullMemoryCardFlag = !this.showFullMemoryCardFlag;
        
        window.ga('newmedia.send', {
          hitType: 'event',
          eventCategory: 'Polularity',
          eventAction: 'click',
          eventLabel: `[${Utils.detectPlatform()}] [Letter view] [信件${memory.id}]`,
        });
      } else {
        this.showFullMemoryCardFlag = !this.showFullMemoryCardFlag;
      }
    },
    // filterFeaturedMemory(flag) {
    //   if (flag) {
    //     if (!this.filterButtonActiveFlag) {
    //       // 顯示精選信件
    //       this.filterButtonActiveFlag = true;
    //       this.$refs.slick.filter((index) => {
    //         return this.featuredMemoryIndexList.includes(index);
    //       });
    //       this.goToMemory(this.featuredMemoryListLength - 1);
    //       // this.goToMemory(this.memoryListLength - 1);
    //     } else {
    //       if (this.currentMailOfPage !== this.featuredMemoryListLength - 1) {            
    //         this.goToMemory(this.memoryListLength - 1);
    //       }
    //     }
    //     window.ga('newmedia.send', {
    //       hitType: 'event',
    //       eventCategory: 'Button',
    //       eventAction: 'click',
    //       eventLabel: `[${Utils.detectPlatform()}] [Selected]`,
    //     });
    //   } else {
    //     // 顯示所有信件
    //     this.filterButtonActiveFlag = false;
    //     this.$refs.slick.unfilter();
    //     this.goToMemory(0);
    //     window.ga('newmedia.send', {
    //       hitType: 'event',
    //       eventCategory: 'Button',
    //       eventAction: 'click',
    //       eventLabel: `[${Utils.detectPlatform()}] [All]`,
    //     });
    //   }
    // },
    calcAdjacentIndex(dir) {
      if (this.filterButtonActiveFlag) {
        if (dir === -1) {
          if (this.currentMailOfPage - 1 < 0) {
            return this.memoryListLength - 1;
          } else {
            return this.memoryListLength - (this.featuredMemoryListLength - this.currentMailOfPage + 1);
          }
        } else {
          if (this.currentMailOfPage + 1 >= this.featuredMemoryListLength) {
            return this.memoryListLength - (this.featuredMemoryListLength);
          } else {
            return this.memoryListLength - (this.featuredMemoryListLength - this.currentMailOfPage - 1);
          }
        }
      } else {
        if (dir === -1) {
          if (this.currentMailOfPage - 1 < 0) {
            return this.memoryListLength - 1;
          } else {
            return this.currentMailOfPage - 1;
          }
        } else {
          if (this.currentMailOfPage + 1 >= this.memoryListLength) {
            return 0;
          } else {
            return this.currentMailOfPage + 1;
          }
        }
      }
    },
    updatePage(direction) {
      this.currentMailOfPage += direction === 'next' ? 1 : -1;
    },
    goPreviousMemory() {
      this.updatePage('previous');
      this.$refs.slick.goTo(this.currentMailOfPage);
      // make -1 to last one
      this.currentMailOfPage = this.$refs.slick.currentSlide();
    },
    goNextMemory() {
      this.updatePage('next');
      this.$refs.slick.goTo(this.currentMailOfPage);
      // make current to newest one
      this.currentMailOfPage = this.$refs.slick.currentSlide();
    },
    goToMemory(index) {
      this.$refs.slick.goTo(index);
    }
  },
  created() {
    this.fetchMemoryList(this.currentPage);
  },
}
</script>

<style lang="scss" scoped>
  .gallery-container {
    width: 100%;
    text-align: center;
    padding: 50px 0 20px 0;
  }

  .gallery-header-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 20%;
    padding: 5px 0;
    @media only screen and (min-width: 1024px) {
      padding: 25px 0;
    }
    .filter-button-wrapper {
      position: relative;
      display: flex;
      justify-content: center;
      color: #57b09f;
      .filter-button {
        box-sizing: content-box;
        margin: 0 10px;
        cursor: pointer;
        transition: .333s ease-in-out;
        border-bottom: solid 1px rgba($color: #57b09f, $alpha: 0);
      }
      .active {
        font-weight: bold;
        border-bottom: solid 1px #57b09f;
      }
      .ten-mails-button {
        cursor: pointer;
      }
    }
  }

  .write-mail-button-wrapper {
    pointer-events: none;
    position: relative;
    width: 100%;
    text-align: center;
    margin: 10px 0;
    @media only screen and (min-width: 1024px) {
      margin: 3% 0;
    }
    .write-mail-button {
      background-color: #57b09f;
      border: none;
      // color: white;
      color: #dededebb;
      padding: 15px 60px;
      text-align: center;
      text-decoration: none;
      display: inline-block;
      font-size: 16px;
      margin: 4px 2px;
      line-height: 1;
      // cursor: pointer;
      cursor: no-drop;
    }
    .mail-counter {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      color: #9d9d9d;
      padding: 0 10px;
      @media only screen and (min-width: 769px) {
        position: relative;
        padding: 10px 0;
      }
    }
    .event-dead {
      font-size: 0.7rem;
      line-height: 0;
      color: #dedede;
    }
  }

  .gallery-wrapper {
    position: relative;
    .direction-button-wrapper {
      position: absolute;
      top: 0;
      width: 8vw;
      height: 100%;
      display: flex;
      align-items: center;
      background-color: rgba($color: #f1f1f1, $alpha: 0.5);
      @media only screen and (max-width: 768x) {
        display: none;
      }
      @media only screen and (min-width: 769px) and (max-width: 1023px) {
        width: 5vw;
      }
      @media only screen and (min-width: 1025px) and (max-width: 1280px) {
        width: 5vw;
      }
      @media only screen and (min-width: 1281px) {
        width: 15vw;
      }
    }
    .readmore-alt-button {
      position: absolute;
      height: 100%;
      cursor: pointer;
    }
    .pre {
      left: 0;
      justify-content: flex-end;
    }
    .next {
      right: 0;
      justify-content: flex-start;
    }
    .direction-button {
      visibility: hidden;
      position: relative;
      width: 40px;
      height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      padding: 10px;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      transition: .333s ease-in-out;
      cursor: pointer;
    }
    .next-button {
      transform: translateX(-24px);
    }
    .pre-button {
      transform: translateX(26px);
    }
    .direction-mail-button {
      visibility: visible;
      background-color: #57b09f;
      img {
        width: 20px;
        height: 20px;
      }
      @media only screen and (min-width: 1281px) {
        width: 50px;
        height: 50px;
        border-radius: 25px;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
    .direction-page-button {
      visibility: visible;
      width: 50px;
      height: 50px;
      border-radius: 25px;
      background-color: #ffffff;
      padding: 15px;
      img {
        width: 20px;
        height: 20px;
      }
      @media only screen and (min-width: 1281px) {
        width: 60px;
        height: 60px;
        border-radius: 30px;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
    .direction-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      margin-top: 55px;
      color: #6f6f6f;
      font-size: 0.9rem;
      white-space: nowrap;
      @media only screen and (min-width: 1281px) {
        margin-top: 65px;
      }
    }
  }
  .gallery-hide {
    opacity: 0;
  }

  .loader-wrapper {
    height: 550px;
    margin: 1%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #7B7A7A;
    @media only screen and (min-width: 320px) and (max-width: 374px) {
      height: 365px;
    }
    @media only screen and (min-width: 374px) and (max-width: 410px) {
      height: 465px;
    }
  }

  .fade-in {
    animation-name: fadeIn;
    animation-timing-function: ease-in-out;
    animation-duration: 2s;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    80% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
